/**
 * Programmatically triggers a file download, with a fix for Safari.
 * Fetches the file and creates a local Blob URL to force download.
 * @param url The URL of the file to download.
 * @param fileName The name to save the file as.
 */
export const triggerFileDownload = async (url: string, fileName?: string) => {
  try {
    // This will fail if CORS is not properly set up on the server
    // If the issue arises, let the relevant team know to fix CORS settings
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.setAttribute('download', fileName || 'download');
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
  } catch (error) {
    // On safari it might open the file in a new tab instead of downloading it
    // To fix that the above try block needs to be used with proper CORS setup
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName || 'download');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
};
